class DevelopmentModel {
  public name: string;
  public customer: string;
  public local: string;
  public customerId: number;
  public readonly createdAt?: Date;
  public modifiedAt?: Date;

  constructor(
    name: string = "",
    customer: string = "",
    local: string = "",
    customerId: number = 0,
    createdAt: Date = new Date(),
    modifiedAt: Date = new Date()
  ) {
    this.name = name;
    this.customer = customer;
    this.local = local;
    this.customerId = customerId;
    this.createdAt = createdAt;
    this.modifiedAt = modifiedAt;
  }
}

export default DevelopmentModel;
